import { EventEmitter } from "fbemitter";
import { runSearch } from "../../rest/Search";
import { Polyglot } from "../../polyglot";

import { EntityType } from "../../models";
import { SearchProps } from "../components/Pages/SearchProps";
import { SearchFormStore } from "../components/Pages/Search/Store";
import { FlagStore } from "../flux/Flag";
import { ErrorStore } from "../flux/Error";
import { SearchWithSpinnerCommand, getCurrentDivisionMiddleware, Refresher } from "../components/Pages/commands/EntitySearchCommand";

// TabSearchConfigurator is a class which helps to setup searchbox on every Entity tab
// Those search boxes has implicit dependency – current division id
// Also we need to prepare new search when current division is change (even on different tab)
export class TabSearchConfigurator
{
    readonly searchInProgressStore = new FlagStore();
    readonly searchErrorStore = new ErrorStore();
    readonly searchBoxProps: SearchProps;
    
    constructor(polyglot: Polyglot, entityType: EntityType, getCurrentDivisionId: () => number, divisionEmitter: EventEmitter, tableTitleDispatchToken: string)
    {
        const refresher = new Refresher(divisionEmitter, getCurrentDivisionId);
        const refreshCommand = new SearchWithSpinnerCommand(polyglot, entityType, runSearch, refresher, this.searchInProgressStore.dispatchToken, this.searchErrorStore.dispatchToken);
        refreshCommand.labelDispatchToken = tableTitleDispatchToken;
        refresher.searchCmd = refreshCommand;
        refresher.bindParameters({ DivisionId: null }, true);
        
        const searchBoxCommand = new SearchWithSpinnerCommand(polyglot, entityType, runSearch, refresher, this.searchInProgressStore.dispatchToken, this.searchErrorStore.dispatchToken);
        searchBoxCommand.addRequestMiddleware(getCurrentDivisionMiddleware(getCurrentDivisionId));
    
        searchBoxCommand.labelDispatchToken = tableTitleDispatchToken;
        this.searchBoxProps = {
            searchInProgressStore: this.searchInProgressStore,
            searchErrorStore: this.searchErrorStore,
            searchFormStore: new SearchFormStore(),
            searchCommand: searchBoxCommand,
            refresher: refresher,
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/init/configureSearchBox.ts